import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery, gql } from '@apollo/client';
import { Box } from '@rebass/emotion';
import { css } from '@emotion/core';

import theme from '@app/styles/theme';
import { H1, H4 } from '@app/shop/components/typography';
import { Alert, AlertTitle } from '@app/shop/components/Alert';

import CouponItems from './CouponItems';
import messages, {
  FormattedMessageFAQ,
  FormattedMessageEmptyInstructions,
} from './Coupons.messages';
import { CouponsQuery } from './__generated__/CouponsQuery';

export const COUPONS_QUERY = gql`
  query CouponsQuery {
    magento2 {
      getCustomerCoupons {
        allCoupons {
          id
          name
          code
          fromDate
          toDate
        }
      }
    }
  }
`;

const Coupons: FunctionComponent = () => {
  const {
    data: couponData,
    loading: isLoadingCoupons,
  } = useQuery<CouponsQuery>(COUPONS_QUERY);
  const couponItems = couponData?.magento2?.getCustomerCoupons?.allCoupons;
  if (isLoadingCoupons) return null;

  return (
    <>
      <H1>
        <FormattedMessage {...messages.title} />
      </H1>

      <H4
        uppercase={false}
        as="h2"
        css={css`
          color: ${theme.colors.gray};
        `}
      >
        <FormattedMessage {...messages.subtitle} />
      </H4>

      {couponItems?.length ? (
        <>
          <Box pt={20} pb={40}>
            <CouponItems allCoupons={couponItems} />
          </Box>

          <FormattedMessageFAQ />
        </>
      ) : (
        <>
          <Box pt={20} pb={40} mb={20}>
            <Alert>
              <AlertTitle>
                <FormattedMessage {...messages.empty} />
              </AlertTitle>
            </Alert>
          </Box>

          <FormattedMessageEmptyInstructions />
        </>
      )}
    </>
  );
};

export default Coupons;
